import React, { memo, useState } from 'react';
import { 
  Box, 
  Text, 
  Button, 
  SimpleGrid, 
  Heading, 
  HStack, 
  Collapse,
  Divider
} from '@chakra-ui/react';

const AdditionalServices = memo(({ 
  servicos, 
  additionalSelected, 
  setAdditionalSelected,
  isMensalista
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Se não for mensalista, não exibimos este componente
  if (!isMensalista) {
    return null;
  }

  // Não precisamos mais calcular o total dos serviços adicionais
  // já que o total será exibido apenas no componente TotalGeral

  return (
    <Box
      p={6}
      bg="linear-gradient(180deg, rgba(45,55,72,0.9) 0%, rgba(26,32,44,0.9) 100%)"
      borderRadius="2xl"
      boxShadow="2xl"
      border="1px solid"
      borderColor="whiteAlpha.100"
      backdropFilter="blur(10px)"
      mb={6}
    >
      <HStack mb={4} justify="space-between" align="center">
        <Heading size="md" color="yellow.400" letterSpacing="wide">
          Serviços Adicionais
        </Heading>
        <Button
          onClick={() => setIsOpen(!isOpen)}
          bg={isOpen ? "yellow.400" : "whiteAlpha.200"}
          color={isOpen ? "black" : "white"}
          _hover={{ bg: isOpen ? "yellow.500" : "whiteAlpha.300" }}
          _active={{ bg: isOpen ? "yellow.600" : "whiteAlpha.400" }}
          borderRadius="xl"
          size="md"
          px={6}
          fontWeight="bold"
        >
          {isOpen ? "Fechar" : "Adicionar"}
        </Button>
      </HStack>

      <Collapse in={isOpen} animateOpacity>
        <Box mt={4} className="hide-scrollbar">
          <Divider mb={4} borderColor="whiteAlpha.300" />
          
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
            {servicos.map((servico) => {
              const isSelected = additionalSelected.includes(servico.id);
              
              return (
                <Box
                  key={servico.id}
                  bg="whiteAlpha.50"
                  _hover={{ bg: isSelected ? 'yellow.500' : 'whiteAlpha.100', transform: 'translateY(-2px)' }}
                  transition="all 0.2s"
                  borderRadius="xl"
                  boxShadow="lg"
                  border="1px solid"
                  borderColor={isSelected ? "yellow.400" : "whiteAlpha.200"}
                  overflow="hidden"
                  p={4}
                  cursor="pointer"
                  onClick={() => {
                    setAdditionalSelected(prev => 
                      prev.includes(servico.id) 
                        ? prev.filter(id => id !== servico.id) 
                        : [...prev, servico.id]
                    );
                  }}
                >
                  <HStack spacing={4} align="flex-start">
                    <Box
                      p={isSelected ? 2 : 3}
                      w={isSelected ? "44px" : "40px"}
                      h={isSelected ? "44px" : "40px"}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={isSelected ? "md" : "full"}
                      bg={isSelected ? "yellow.400" : "yellow.40020"}
                      color={isSelected ? "black" : "yellow.400"}
                      fontSize="xl"
                      fontWeight="bold"
                      boxShadow={isSelected ? "md" : "none"}
                      border={isSelected ? "1px solid" : "none"}
                      borderColor={isSelected ? "yellow.500" : "transparent"}
                    >
                      {isSelected ? '✓' : '+'}
                    </Box>
                    <Box flex={1}>
                      <Text fontSize="lg" color="white" fontWeight="bold" mb={1}>
                        {servico.nome}
                      </Text>
                      <Text fontSize="sm" color="gray.300" mb={2}>
                        {servico.descricao}
                      </Text>
                      <Box 
                        py={1} 
                        px={3} 
                        bg="green.40020"
                        borderRadius="full"
                        border="1px solid"
                        borderColor="green.400"
                        display="inline-block"
                      >
                        <Text color="green.400" fontSize="md" fontWeight="bold">
                          R$ {typeof servico.valor === 'number' ? servico.valor.toFixed(2).replace('.', ',') : '--'}
                        </Text>
                      </Box>
                    </Box>
                  </HStack>
                </Box>
              );
            })}
          </SimpleGrid>

          {/* Removido o total de adicionais conforme solicitado */}
        </Box>
      </Collapse>
      
      {!isOpen && additionalSelected.length > 0 && (
        <HStack mt={2} spacing={2}>
          <Text color="gray.300" fontSize="sm">
            {additionalSelected.length} {additionalSelected.length === 1 ? 'serviço adicional' : 'serviços adicionais'} selecionado{additionalSelected.length > 1 ? 's' : ''}
          </Text>
        </HStack>
      )}
    </Box>
  );
});

export default AdditionalServices;
